import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $requesting, $success, $failure } from "services/form/action";

export const MODULE = "Onboarding";

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $create = ActionCreator.Async(MODULE, "Create", (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/public/user`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $save = ActionCreator.Default(MODULE, "Save", (payload) => {
  return (dispatch) => {
    dispatch($save.action({ payload }));
    return true;
  };
});
